import { ArticleHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'clsx';

import { withDeviceType } from '../../../../utils/withDeviceType';
import { DealStepModalHeadingSection } from '../DealStepModalHeadingSection';
import { NBSP } from '../../../../constants/symbols';
import { IDealStepsModalContentProps } from '../../types';

import * as styles from './styles.css';

const RosreestrRegistrationStepModalContent: React.FC<React.PropsWithChildren<IDealStepsModalContentProps>> = props => {
  return (
    <>
      <DealStepModalHeadingSection
        imageX1="https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/deal_steps_v2/rosreestr_x1.png"
        imageX2="https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/deal_steps_v2/rosreestr_x2.png"
        chip="В среднем 1 — 5 дней"
        title={props.title}
        subtitle="Мы предлагаем самую быструю регистрацию в Росреестре на рынке."
      />
      <ol className={cn(styles['content'], styles[props.deviceType])}>
        <li className={cn(styles['step'], styles[props.deviceType])}>
          <ArticleHeading2 as="h5">1. Отправка документов</ArticleHeading2>
          <UIText1 as="p">Все подписанные документы мы онлайн отправим в{NBSP}Росреестр и оплатим госпошлину.</UIText1>
        </li>
        <li className={cn(styles['step'], styles[props.deviceType])}>
          <ArticleHeading2 as="h5">2. Регистрация</ArticleHeading2>
          <UIText1 as="p">
            После успешной регистрации права собственности в Росреестре участникам сделки на электронную почту вышлем
            документы, подтверждающие регистрацию. Если захотите, можете получить бумажную копию документа в МФЦ.
          </UIText1>
        </li>
        <li className={cn(styles['step'], styles[props.deviceType])}>
          <ArticleHeading2 as="h5">3. Взаиморасчёты</ArticleHeading2>
          <UIText1 as="p">
            После успешной регистрации выполните условия в зависимости от выбранного способа взаиморасчётов.
          </UIText1>
        </li>
      </ol>
    </>
  );
};

const RosreestrRegistrationStepModalContentWithDeviceType = withDeviceType(RosreestrRegistrationStepModalContent);
export { RosreestrRegistrationStepModalContentWithDeviceType as RosreestrRegistrationStepModalContent };
